import React from 'react';

/** Centered circular + for creating organizations (matches org tree add button styling). */
const GroupsCreateFab = ({ onClick, ariaLabel = 'Create' }) => (
  <div className="groups-org-create-fab-wrap">
    <button
      type="button"
      className="groups-org-create-fab-btn"
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <svg
        className="groups-org-create-fab-btn__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    </button>
  </div>
);

export default GroupsCreateFab;
